import { DeviceCode } from 'packages/smart-home-support/models';
import { PartnerCode, ProductCode } from 'packages/smart-home-support/partner';
import { Env } from '@backoffice/fast-payments-client-js-sdk';

export enum Partner {
  Verizon = 'Verizon',
  Sprint = 'Sprint',
  Asurion = 'Asurion',
  Test = 'TestPartner',
}

export enum PartnerConfigName {
  Verizon = 'SHS-WEB',
  Sprint = 'SHS-SPRINT',
  Asurion = 'SHS-ASURION',
  TechCoachHome = 'TCH-WEB',
}

export type CognitoConfig = {
  COGNITO_CLIENT_ID: string;
  COGNITO_USER_POOL_ID: string;
};

export type AuthAPIConfig = {
  AUTH_API_PARTNER_CODE?: PartnerCode;
};

export type PartnerAPIConfig = CognitoConfig & AuthAPIConfig;

export type SmartHomeConfig = PartnerAPIConfig & {
  CREATE_TRANSACTION_URL: string;
  FAST_PAYMENT_ENV: Env;
  SH_ENROLLMENT_API_BASE_URL: string;
  SH_USER_DETAILS_API_BASE_URL: string;
  SH_USER_POOL_API_BASE_URL: string;
  IS_DEMO_MODE: boolean; // Sets APIs to be mocked
  RECAPTCHA_V2_SITE_KEY: string;
  RECAPTCHA_V3_SITE_KEY: string;
  MIXPANEL_TOKEN_SONASH: string;
};

export interface ExtraLoginData {
  [key: string]: string | number | boolean | undefined;
}

export interface SecurityTokenRequest {
  correlationId: string;
  phoneNumber: string;
  partner: string;
  sourceApp?: string;
}

export interface SecurityTokenResponse {
  token: string;
  encryptionKey: string;
}

export interface GetTransactionIdResponse {
  pciToken: string;
  billingAccountNumber: string;
}

export interface GetTaxDetailsResponse {
  totalTaxAmount: string;
}

export enum ChannelCode {
  Web = 'Web',
  Phone = 'Phone',
  WebGlow = 'Web-Glow',
}

export interface EnrollUserRequest {
  recaptchaToken?: string;
  recaptchaVersion?: RecaptchaVersion;
  agentId?: string;
  storeCode?: string;
  saleSessionId?: string;
  partner: Partner;
  correlationId: string;
  firstName: string;
  lastName: string;
  addresses: Address[];
  phoneNumber: string;
  emailAddress: string;
  channelCode?: ChannelCode;
  referrerCode?: string;
  vendorData?: string;
  sourceApp?: string;
}

export interface CreateUserRequest {
  partner: string;
  mdn: string;
  extraLoginData?: ExtraLoginData;
}

export interface ShoppingCartRequest {
  partner: Partner;
  correlationId: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
}

export interface EnrollUserResponse {
  planId: string;
}

export interface Address {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  countryCode: string;
  postalCode: string;
  addressUsage: AddressUsage;
}

export enum AddressUsage {
  Shipping = 'Shipping',
  Billing = 'Billing',
}

export interface Payment {
  pan_type: string;
  cc_no: number;
  cvv: number;
  cc_exp_month: number;
  cc_exp_year: string;
  saveCard: string;
}

export interface AJAXConfig {
  url: string;
  encryption_key: string;
  appName: string;
  security_token: string;
}

export interface TransactionContact {
  fname: string;
  mname: string;
  lname: string;
  addr1: string;
  addr2: string;
  city: string;
  state: string;
  zip: string;
  email: string;
}

export type Device = {
  id: string;
  created: number;
  type: DeviceCode;
};

export type Devices = Array<Device>;
export type TestGroups = Array<string>;

export interface Home {
  devices?: Devices;
}

export interface User {
  mdn: string;
  isMdnVerified: boolean;
  home: Home;
  productCode?: ProductCode;
  testGroups?: TestGroups;
}

export interface UserAttributes {
  [key: string]: string;
}

export enum RecaptchaVersion {
  V2 = 'v2',
  V3 = 'v3',
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/models.ts